<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Video Series</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <strong>Manage Videos</strong>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              style="margin-left: 15px;"
              :to="{ name: 'VideoSeriesAddVideos', params: { id: $route.params.id }}"
            >
              Add new Video
            </router-link>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              style="margin-left: 15px;"
              :to="{ name: 'VideoSeriesOrderVideos', params: { id: $route.params.id }}"
            >
              Order Videos
            </router-link>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              :to="{ name: 'VideoSeriesEdit', params: { id: $route.params.id }}"
            >
              Back to General
            </router-link>
          </div>

          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by Video title"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <div class="table-responsive">
              <table class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Thumbnail</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="total">
                  <tr v-for="item in videos" :key="item.id" :data-id="item.id">
                    <td class="table-list__cell--narrow">{{ item.id }}</td>
                    <td class="table-list__cell--narrow">
                      <img :src="item.thumbnail" :alt="item.title" style="max-height: 150px;">
                    </td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow">
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'VideoEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <open-on-site
                        :source-route="item.route"
                      />
                      <button
                        class="btn btn-danger btn-sm"
                        @click="detachVideo(item)"
                      >
                        Delete
                        <span class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" class="text-center">
                      There are no video yet. Go to 'Add New Video' to add new ones.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';

export default {
  name: 'VideoSeriesManageVideos',

  components: {
    pager: Pager,
    'open-on-site': OpenOnSiteButton,
  },

  data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      videos: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getVideos();
    }, 400),
    offset() {
      this.getVideos();
    },
  },

  mounted() {
    this.getVideos();
  },

  methods: {
    getVideos() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/video-series/${this.$route.params.id}/videos`, {
        params: {
          search_string: searchString,
          page,
          with: ['cover'],
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;

          const videosArr = _.cloneDeep(response.data);
          delete videosArr.meta;
          this.videos = videosArr;
        }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        console.error(error);
      });
    },
    detachVideo(video) {
      if (window.confirm(`Do you really want to detach Video ${video.title} with id = ${video.id}?`)) {
        const $btnDeleteLoader = $(`table.entities tr[data-id="${video.id}"] .btn-danger .btn-loader`);
        const postFormData = new FormData();
        $btnDeleteLoader.show();
        postFormData.append('ids[]', video.id);
        this.$apiHttp.post(
          `${this.$config.app_api.prefix}media/video-series/${this.$route.params.id}/detach-videos`,
          postFormData,
        ).then(() => {
          $btnDeleteLoader.hide();
          this.getVideos();
        }).catch((error) => {
          console.error('Error in detach video request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage(offset) {
      this.offset = offset;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ManageVideos.vue?9e91c086